/* eslint-disable @typescript-eslint/unbound-method */
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ZxComponentFormComponent } from '../zx-component-form/zx-component-form.component';

@Component({
  selector: 'app-zx-component-create',
  templateUrl: './zx-component-create.component.html',
  styleUrls: ['./zx-component-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ZxComponentFormComponent],
})
export class ZxComponentCreateComponent {
  constructor() {}
}
